import { AuthService } from '@app/shared/services/auth.service';
import { Inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { WindowToken } from '@app/shared/window.token';
import { Observable } from 'rxjs';
import { OrgBaseGuard } from './org-base.guard';
import { SkillsGuard } from './skills.guard';
import { SkillStandardsGuard } from './skill-standards.guard';
import { SkillsPlatformGuard } from '@app/skills-platform-lxp-ui';

@Injectable({
  providedIn: 'root',
})
export class SkillsRedirectGuard extends OrgBaseGuard {
  constructor(
    @Inject(WindowToken) windowRef: Window,
    authService: AuthService,
    protected override router: Router,
    private skillsGuard: SkillsGuard,
    private skillStandardsGuard: SkillStandardsGuard,
    private skillsPlatformGuard: SkillsPlatformGuard
  ) {
    super(authService, windowRef, router);
    this.routeDirectory = '/skills';
  }

  public override get hasPermission() {
    return (
      this.skillsGuard.hasPermission || this.skillStandardsGuard.hasPermission
    );
  }

  public override canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.skillsGuard.hasPermission) {
      // if user has skills plus enabled, hide skills list and redirect to roles page
      return !this.skillsPlatformGuard.hasPermission
        ? this.router.parseUrl(this.resolveOrgUrl('/list'))
        : this.router.parseUrl(this.resolveOrgUrl('/roles'));
    }
    if (this.skillStandardsGuard.hasPermission) {
      return this.router.parseUrl(this.resolveOrgUrl('/skillstandards'));
    }
    return this.router.parseUrl('/');
  }
}
